module.exports = __webpack_public_path__ + "img/2金属制品.832a1775.gif";